import type { FunctionComponent } from 'react';

import { FormGroup, LabeledPasswordInput, LabeledTextInput } from '../../../generic/Forms';
import Link from '../../../generic/Link';
import Text from '../../../generic/Text';
import type { TextInputOnChange } from '../../../generic/Forms';

import JiraSettingsSection from './JiraSettingsSection';

export type JiraSettingsCredentialsProps = {
  username?: string;
  password?: string;
  onUsernameChange: TextInputOnChange;
  onPasswordChange: TextInputOnChange;
};

const JIRA_TOKEN_DOCS = 'https://confluence.atlassian.com/cloud/api-tokens-938839638.html';

/**
 * JiraSettingsCredentials
 */
const JiraSettingsCredentials: FunctionComponent<JiraSettingsCredentialsProps> = ({
  username = '',
  onUsernameChange,
  password = '',
  onPasswordChange,
}) => (
  <JiraSettingsSection heading="Credentials">
    <div>
      <FormGroup direction="row">
        <LabeledTextInput
          labelVariant="legacy"
          label="Username"
          value={username}
          onChange={onUsernameChange}
        />
        <LabeledPasswordInput
          label="API Token / Password"
          value={password}
          onChange={onPasswordChange}
        />
      </FormGroup>
    </div>
    <div>
      <Text.Micro>
        Note: Jira Cloud no longer supports API password authentication.
        {' '}
        Jira Cloud users must instead
        {' '}
        <Link to={JIRA_TOKEN_DOCS} openInNewTab>create a Jira API token</Link> and enter it here.
        {' '}
        Some on-premises Jira installations may still support password authentication.
      </Text.Micro>
    </div>
  </JiraSettingsSection>
);

export default JiraSettingsCredentials;
